import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './internal/Symbol.mjs';
import { commonThreadLocal18t70xomalc6z as commonThreadLocal } from './internal/ThreadLocal.mjs';
import { createEventLoop3pvigh4qbw0m0 as createEventLoop } from './EventLoop.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function delta($this, unconfined) {
  return unconfined ? 4294967296n : 1n;
}
var EventLoopClass;
function EventLoop() {
  if (EventLoopClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.q13_1 = 0n;
        this.r13_1 = false;
        this.s13_1 = null;
      }
      t13() {
        var tmp0_elvis_lhs = this.s13_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        var tmp1_elvis_lhs = queue.vj();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var task = tmp_0;
        task.u11();
        return true;
      }
      u13(task) {
        var tmp0_elvis_lhs = this.s13_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ArrayDeque().rj();
          this.s13_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        queue.tj(task);
      }
      v13() {
        return this.q13_1 >= delta(this, true);
      }
      w13() {
        var tmp0_safe_receiver = this.s13_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1();
        return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
      }
      x13(unconfined) {
        this.q13_1 = add(this.q13_1, delta(this, unconfined));
        if (!unconfined)
          this.r13_1 = true;
      }
      y13(unconfined) {
        this.q13_1 = subtract(this.q13_1, delta(this, unconfined));
        if (this.q13_1 > 0n)
          return Unit_instance;
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.r13_1) {
          this.z13();
        }
      }
      w12(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      z13() {
      }
    }
    initMetadataForClass($, 'EventLoop');
    EventLoopClass = $;
  }
  return EventLoopClass;
}
var ThreadLocalEventLoopClass;
function ThreadLocalEventLoop() {
  if (ThreadLocalEventLoopClass === VOID) {
    class $ {
      constructor() {
        ThreadLocalEventLoop_instance = this;
        this.a14_1 = commonThreadLocal(new (Symbol())('ThreadLocalEventLoop'));
      }
      b14() {
        var tmp0_elvis_lhs = this.a14_1.d14();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = createEventLoop();
          ThreadLocalEventLoop_getInstance().a14_1.e14(this_0);
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForObject($, 'ThreadLocalEventLoop');
    ThreadLocalEventLoopClass = $;
  }
  return ThreadLocalEventLoopClass;
}
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance === VOID)
    new (ThreadLocalEventLoop())();
  return ThreadLocalEventLoop_instance;
}
//region block: exports
export {
  ThreadLocalEventLoop_getInstance as ThreadLocalEventLoop_getInstancenusaemxxykog,
  EventLoop as EventLoopljivmgnf56lj,
};
//endregion

//# sourceMappingURL=EventLoop.common.mjs.map
